import type { ProgramImage, ProgramImageKind } from './useProgram';

export { Divider, IMAGES_HINT, ImageRow } from '../../shared/ImageRow';

// The legacy form's labels. The first two are uploaded; the rest are only shown, as the legacy
// images table shows them, and only when present.
export const IMAGE_LABELS: Record<ProgramImageKind, string> = {
  investigation_image: 'Investigation Image (student)',
  isn_image: 'ISN Image (student)',
  it_image: 'IT Image (student)',
  program_image: 'Program Image (student)',
  reading_card_image: 'Reading Card Image',
  se_image: 'SE Image (student)',
  student_text_image: 'Large Student Text Image',
};
export const UPLOADABLE: ProgramImageKind[] = ['program_image', 'reading_card_image'];

// A row for an image the program doesn't have yet (the New Program page).
export const emptyImage = (kind: ProgramImageKind): ProgramImage => ({
  file_name: null, kind, thumb_url: null, url: null,
});
